import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { EditColumnsIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import useCrmObjectTypeTracking from 'framework-listing-lib/internal/hooks/useCrmObjectTypeTracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ListingLibEditColumnsButton({
  hasIcon = true,
  disabled = false,
  tooltipProps,
  modalProps
}) {
  const {
    trackCrmTableInteraction
  } = useCrmObjectTypeTracking();
  const handleOpenModal = useCallback(() => {
    listingLibObserver.openEditColumnsModal(modalProps);
    trackCrmTableInteraction({
      action: 'open-edit-columns-modal'
    });
  }, [modalProps, trackCrmTableInteraction]);
  return /*#__PURE__*/_jsx(Tooltip, Object.assign({
    disabled: !tooltipProps
  }, tooltipProps, {
    children: /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "crm-listing-edit-columns-button",
      onClick: handleOpenModal,
      disabled: disabled,
      size: "extra-small",
      use: "tertiary-extra-light",
      children: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        gap: 4,
        children: [hasIcon && /*#__PURE__*/_jsx(EditColumnsIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "frameworkListingLib.tableActions.editColumns"
        })]
      })
    })
  }));
}